import { configureStore ,combineReducers} from "@reduxjs/toolkit"
import clearAllFlagSlice from "./clearAllFlagSlice";
import userSlice from "./userSlice"
import pupilProgressSlice from "./pupilProgressSlice";
import storageSession from "redux-persist/lib/storage/session"
import { persistReducer } from "redux-persist"
import assessmentSlice from  "./assessmentSlice";
import markingSlice from "./markingSlice";
import newuserSlice from "./newuserSlice";
import loginSlice from "./loginSlice";
import classesSlice from "./classesSlice"
import stylesSlice from "./stylesSlice"


const persistConfig = {
  key: "auth",
  storage: storageSession,
};

export const userReducer = combineReducers({
  userData: userSlice,
  pupilProgress:pupilProgressSlice,
  assessmentData: assessmentSlice,
  marking:markingSlice,
  clearAllFlag:clearAllFlagSlice,
  newUser:newuserSlice,
  login:loginSlice,
  classes: classesSlice,
  styleData:stylesSlice
})

const persistedReducer = persistReducer(persistConfig, userReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export default store;
